import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import type { FormulaRegionTypeCardFragment } from "../../client/generated";
import { RegionTypeCard } from "../RegionTypeCard";
import { useTranslation } from "react-i18next";

type Props = {
  fragment: FormulaRegionTypeCardFragment;
  dispatch: Dispatch<EditorAction>;
};

export function FormulaRegionTypeCard({ fragment, dispatch }: Props) {
  const { t } = useTranslation();

  const onConvert = () => {
    dispatch({
      type: "switchToRegionTab",
      tab: "formula",
      regionId: fragment.id,
    });
  };

  return (
    <RegionTypeCard
      title={t("FormulaRegionTypeCard.title")}
      description={t("FormulaRegionTypeCard.description")}
      onConvert={onConvert}
    />
  );
}
